<template>
  <div class="poster" v-if="painting">
    <vue-canvas-poster :widthPixels="750" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
  </div>
</template>

<script>
// 横版 750 * 750
// 竖版 750 * 1334
// https://sunniejs.github.io/vue-canvas-poster/
import { mapGetters } from 'vuex'
import { Icon } from 'vant'
import { VueCanvasPoster } from 'vue-canvas-poster'
import { padding } from '@/utils/index'
import bg from '@/assets/images/bg1.png'
import qrcode_img from '@/assets/images/qrcode_for_mp.jpg'

export default {
  name: 'home',
  components: {
    [Icon.name]: Icon,
    VueCanvasPoster
  },
  props: {
    posterData: {
      type: Object
    }
  },
  data () {
    return {
      painting: null
    }
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ])
  },
  created () {
    if (this.posterData.is_vertical) {
      this.render()
    } else {
      this.renderHorizontal()
    }
  },
  methods: {
    render () {
      this.painting = {
        width: '750px',
        height: '1334px',
        background: this.posterData.bg_img,
        // background: '#f4f5f7',
        views: [
          {
            type: 'image',
            url: bg,
            css: {
                top: '0',
                left: '0',
                width: '750px',
                height: '1334px',
            },
          },
          {
            type: 'text',
            text: this.posterData.chicken_soup,
            css: [
              {
                top: '350px',
                left: '60px',
                width: '560px',
                lineHeight: '70px',
                // width: '400px',
                fontSize: '48px',
                fontWeight: '900',
                color: '#fff'
              }
            ]
          },
          {
            type: 'rect',
            css: {
              color: '#fff',
              bottom: '40px',
              left: '30px',
              borderRadius: '10px',
              width: '690px',
              height: '300px'
            }
          },
          {
            type: 'text',
            text: `ID：${this.userprofile.uuid}`,
            css: [
              {
                bottom: '275px',
                right: '60px',
                fontSize: '24px',
                color: '#696969'
              }
            ]
          },
          ...this.renderDate(100, 50),
          ...this.renerUserInfo(285, 80),
          ...this.renderRecord(85, 60),
          ...this.renderQrcode(110, 60)
        ]
      }
    },
    renderDate (top, left) {
      const now = new Date()
      const weekDayMap = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

      return [
        {
          type: 'text',
          text: `${padding(now.getMonth() + 1, 2)}.${padding(now.getDate(), 2)}`,
          css: [
            {
              top: `${top}px`,
              left: `${left}px`,
              fontSize: '68px',
              color: '#fff'
            }
          ]
        },
        {
          type: 'text',
          text: weekDayMap[now.getDay()],
          css: [
            {
              top: `${top + 90}px`,
              left: `${left}px`,
              fontSize: '60px',
              color: '#fff'
            }
          ]
        }
      ]
    },
    renerUserInfo (bottom, left) {
      return [
        {
          type: 'image', // 头像
          url: this.userprofile.avatar_url,
          css: {
            bottom: `${bottom}px`,
            left: `${left}px`,
            borderRadius: '60px',
            width: '100px',
            height: '100px'
          }
        },
        {
          type: 'text', // 昵称
          text: this.userprofile.nickname,
          css: [
            {
              bottom: `${bottom - 40}px`,
              left: `${left - 25}px`,
              fontSize: '28px',
              color: '#000'
            }
          ]
        },
        {
          type: 'text',
          text: `[365一起跑]坚持打卡天数:`,
          css: [
            {
              bottom: `${bottom - 85}px`,
              left: `${left - 25}px`,
              fontSize: '24px',
              color: '#000'
            }
          ]
        },
        {
          type: 'text',
          text: this.posterData.days + '',
          css: [
            {
              bottom: `${bottom - 85}px`,
              left: `${left + 260}px`,
              fontSize: '24px',
              color: 'red'
            }
          ]
        }
      ]
    },
    renderQrcode (bottom, right) {
      return [
        // {
        //   type: 'qrcode',
        //   content: 'http://running.codeeper.com/main/daka',
        //   css: {
        //     bottom: `${bottom}px`,
        //     right: `${right}px`,
        //     color: '#000',
        //     width: '110px',
        //     height: '110px'
        //   }
        // },
        {
          type: 'image',
          url: qrcode_img,
          css: {
            bottom: `${bottom - 12}px`,
            right: `${right - 3}px`,
            width: '140px',
            height: '140px',
          },
        },
        {
          type: 'text',
          text: '扫码打卡',
          css: [
            {
              bottom: `${bottom - 35}px`,
              right: `${right + 15}px`,
              fontSize: '24px',
              color: '#696969'
            }
          ]
        }
      ]
    },
    renderRecord (bottom, left) {
      const numFontSize = '40px'
      const numberlength = 22
      const distance = this.posterData.day_distance + ''
      const minutes = this.posterData.day_minutes + ''
      const totalDistance = this.posterData.total_distance + ''

      return [
        {
          type: 'text',
          text: '今日距离',
          css: [
            {
              bottom: `${bottom}px`,
              left: `${left}px`,
              fontSize: '24px',
              color: '#696969'
            }
          ]
        },
        {
          type: 'text',
          text: distance,
          css: [
            {
              // fontFamily: 'yahei',
              bottom: `${bottom + 40}px`,
              left: `${left}px`,
              fontSize: numFontSize,
              color: '#000'
            }
          ]
        },
        {
          type: 'text',
          text: 'km',
          css: [
            {
              bottom: `${bottom + 40}px`,
              left: `${left + distance.length * numberlength + 5}px`,
              fontSize: '28px',
              color: '#000'
            }
          ]
        },
        {
          type: 'text',
          text: '今日时长',
          css: [
            {
              bottom: `${bottom}px`,
              left: `${left + 160}px`,
              fontSize: '24px',
              color: '#696969'
            }
          ]
        },
        {
          type: 'text',
          text: minutes,
          css: [
            {
              bottom: `${bottom + 40}px`,
              left: `${left + 160}px`,
              fontSize: numFontSize,
              color: '#000'
            }
          ]
        },
        {
          type: 'text',
          text: 'min',
          css: [
            {
              bottom: `${bottom + 40}px`,
              left: `${left + 160 + minutes.length * numberlength + 5}px`,
              fontSize: '28px',
              color: '#000'
            }
          ]
        },
        {
          type: 'text',
          text: '累计距离',
          css: [
            {
              bottom: `${bottom}px`,
              left: `${left + 320}px`,
              fontSize: '24px',
              color: '#696969'
            }
          ]
        },
        {
          type: 'text',
          text: totalDistance,
          css: [
            {
              bottom: `${bottom + 40}px`,
              left: `${left + 320}px`,
              fontSize: numFontSize,
              color: '#000'
            }
          ]
        },
        {
          type: 'text',
          text: 'km',
          css: [
            {
              bottom: `${bottom + 40}px`,
              left: `${left + 320 + totalDistance.length * numberlength + 5}px`,
              fontSize: '28px',
              color: '#000'
            }
          ]
        }
      ]
    },
    renderHorizontal () {
      this.painting = {
        width: '750px',
        height: '750px',
        background: this.posterData.bg_img,
        // background: '#f4f5f7',
        views: [
          {
            type: 'image',
            url: bg,
            css: {
                top: '0',
                left: '0',
                width: '750px',
                height: '750px',
            },
          },
          {
            type: 'text',
            text: this.posterData.chicken_soup,
            css: [
              {
                top: '220px',
                left: '60px',
                width: '600px',
                lineHeight: '70px',
                fontSize: '40px',
                fontWeight: '900',
                color: '#fff'
              }
            ]
          },
          ...this.renerUserInfoHorizontal(20, 20),
          ...this.renderDateHorizontal(27, 20),
          ...this.renderQrcodeHorizontal(70, 35),
          ...this.renderRecordHorizontal(50, 60),
        ]
      }
    },
    renerUserInfoHorizontal (top, left) {
      return [
        {
          type: 'image', // 头像
          url: this.userprofile.avatar_url,
          css: {
            top: `${top}px`,
            left: `${left}px`,
            borderRadius: '60px',
            width: '110px',
            height: '110px'
          }
        },
        {
          type: 'text', // 昵称
          text: '[365一起跑]坚持打卡天数:',
          css: [
            {
              top: `${top + 10}px`,
              left: `${left + 120}px`,
              fontSize: '32px',
              color: '#fff'
            }
          ]
        },
        {
          type: 'text',
          text: this.posterData.days + '',
          css: [
            {
              top: `${top + 8}px`,
              left: `${left + 495}px`,
              fontSize: '34px',
              color: '#fff'
            }
          ]
        }
      ]
    },
    renderDateHorizontal (top, left) {
      const now = new Date()
      const weekDayMap = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

      return [
        {
          type: 'text',
          text: `${padding(now.getMonth() + 1, 2)}月${padding(now.getDate(), 2)}日`,
          css: [
            {
              top: `${top + 55}px`,
              left: `${left + 120}px`,
              fontSize: '32px',
              color: '#fff'
            }
          ]
        },
        {
          type: 'text',
          text: weekDayMap[now.getDay()],
          css: [
            {
              top: `${top + 55}px`,
              left: `${left + 260}px`,
              fontSize: '32px',
              color: '#fff'
            }
          ]
        }
      ]
    },
    renderQrcodeHorizontal (bottom, right) {
      return [
        // {
        //   type: 'rect',
        //   css: {
        //     color: '#fff',
        //     bottom: `${bottom}px`,
        //     right: `${right}px`,
        //     borderRadius: '10px',
        //     width: '140px',
        //     height: '140px'
        //   }
        // },
        // {
        //   type: 'qrcode',
        //   content: 'http://running.codeeper.com/main/daka',
        //   css: {
        //     bottom: `${bottom + 10}px`,
        //     right: `${right + 10}px`,
        //     color: '#000',
        //     width: '120px',
        //     height: '120px'
        //   }
        // },
        {
          type: 'image',
          url: qrcode_img,
          css: {
            bottom: `${bottom}px`,
            right: `${right}px`,
            width: '140px',
            height: '140px',
          },
        },
        {
          type: 'text',
          text: '扫码打卡',
          css: [
            {
              bottom: `${bottom - 35}px`,
              right: `${right + 17}px`,
              fontSize: '28px',
              color: '#fff'
            }
          ]
        }
      ]
    },
    renderRecordHorizontal (bottom, left) {
      const color1 = '#fff'
      const color2 = '#fff'
      const numFontSize = '44px'
      const numberlength = 25
      const distance = this.posterData.day_distance + ''
      const minutes = this.posterData.day_minutes + ''
      const totalDistance = this.posterData.total_distance + ''

      return [
        {
          type: 'text',
          text: '今日距离',
          css: [
            {
              bottom: `${bottom}px`,
              left: `${left}px`,
              fontSize: '28px',
              color: color2
            }
          ]
        },
        {
          type: 'text',
          text: distance,
          css: [
            {
              // fontFamily: 'yahei',
              bottom: `${bottom + 40}px`,
              left: `${left}px`,
              fontSize: numFontSize,
              color: color1
            }
          ]
        },
        {
          type: 'text',
          text: 'km',
          css: [
            {
              bottom: `${bottom + 40}px`,
              left: `${left + distance.length * numberlength + 5}px`,
              fontSize: '30px',
              color: color1
            }
          ]
        },
        {
          type: 'text',
          text: '今日时长',
          css: [
            {
              bottom: `${bottom}px`,
              left: `${left + 160}px`,
              fontSize: '28px',
              color: color2
            }
          ]
        },
        {
          type: 'text',
          text: minutes,
          css: [
            {
              bottom: `${bottom + 40}px`,
              left: `${left + 160}px`,
              fontSize: numFontSize,
              color: color1
            }
          ]
        },
        {
          type: 'text',
          text: 'min',
          css: [
            {
              bottom: `${bottom + 40}px`,
              left: `${left + 160 + minutes.length * numberlength + 5}px`,
              fontSize: '30px',
              color: color1
            }
          ]
        },
        {
          type: 'text',
          text: '累计距离',
          css: [
            {
              bottom: `${bottom}px`,
              left: `${left + 320}px`,
              fontSize: '28px',
              color: color2
            }
          ]
        },
        {
          type: 'text',
          text: totalDistance,
          css: [
            {
              bottom: `${bottom + 40}px`,
              left: `${left + 320}px`,
              fontSize: numFontSize,
              color: color1
            }
          ]
        },
        {
          type: 'text',
          text: 'km',
          css: [
            {
              bottom: `${bottom + 40}px`,
              left: `${left + 320 + totalDistance.length * numberlength + 5}px`,
              fontSize: '30px',
              color: color1
            }
          ]
        }
      ]
    },
    success (src) {
      this.$emit('success', src)
    },
    fail (err) {
      this.$emit('fail', err)
    }
  }
}
</script>
